class GraniteError extends Error {
  constructor(message, api_error = false) {
    super(message);
    this.name = this.constructor.name;
    this.errors = message;
  }
}

export default GraniteError;
